import moment from "moment";

/**
 * Formats a date string or number into a localized date string to a DD MMM YYYY format.
 * @param date - The date string or number to format.
 * @param locale - The locale to use for formatting the date.
 * @returns The formatted date string.
 */
function formatDate(date: string | number, locale: string) {
    if (typeof date === "string") {
        date = date.replace(/-/g, "/").split("T")[0];
    }

    return new Intl.DateTimeFormat(locale, {
        day: "2-digit",
        month: "short",
        year: "numeric",
    })
        .format(new Date(date))
        .toUpperCase();
}

/**
 * Converts a date to an ISO string representation.
 * @param date - The date to convert. It can be a string or a number representing a valid date.
 * @param includeTime - Optional. Specifies whether to include the time in the ISO string. Default is true.
 * @returns The ISO string representation of the date. If `includeTime` is false, only the date part is returned.
 */
function toISOString(date: string | number, includeTime = true) {
    const unFormattedDate = new Date(date);
    const isoString = unFormattedDate.toISOString();

    return includeTime ? isoString : isoString.split("T")[0];
}

function getCurrentDateInOneSiteFormat(locale: string) {
    return moment().locale(locale).format("DD-MMM-YYYY HH:mm");
}

function getCurrentDateInLongFormatWithTime(locale: string) {
    const date = new Date();
    return date.toLocaleString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZone: "Europe/Brussels",
    });
}

export {
    formatDate,
    toISOString,
    getCurrentDateInOneSiteFormat,
    getCurrentDateInLongFormatWithTime,
};
